import React, { useState } from 'react'
import { useFormik } from 'formik';
import { fetchDataFromApi, putDataToTheServer } from '../../../helpers/api';
import AppURL from '../../../constants/AppURL';
import { ToastSuccess } from '../../../constants/Toast';
import { Grid } from '@mui/material';
import { AppSpace, EndBaseLine } from '../../../constants/AppSpace';
import { Button } from '../../../constants/Button';
import InputTextBox from '../../../constants/InputTextBox';
import NepaliInputBox from '../../../constants/NepaliInputBox';
import { handleChangeDate, handleChangePhone, handleNepaliInputChange, handleSelectBox } from '../../../helpers/handleChange';
import { MdOutlinePhone } from 'react-icons/md';
import { CiCalendarDate, CiLocationOn } from 'react-icons/ci';
import { CasteOptions, DistrictOptions, GenderOptions, MemberTypeOptions, MeterStatusOptions, MeterTypeOptions, MunicipalityOptions, ProvinceOptions, ReaderOptions, TapSizeOptions, TapStatusOptions, TapTypeOptions, ToleOptions } from '../../../constants/Options';
import { FiUser } from 'react-icons/fi';
import { IoDocumentsOutline, IoPeopleCircleOutline } from 'react-icons/io5';
import { PiIslandLight, PiNumberCircleNineThin } from 'react-icons/pi';
import FileTextBox from '../../../constants/FileTextBox';
import SecHeading from '../../../constants/SecHeading';
import { TbHexagonNumber2 } from 'react-icons/tb';
import { GiAscendingBlock, GiPathDistance } from 'react-icons/gi';
import useFetchData from '../../../helpers/useFetch';
import useFetchSubData from '../../../helpers/useSubFetch';
import DefaultSelectInputBox from '../../../constants/DefaultSelectBox';
import SelectionBox from '../../../constants/SelectionBox';
import Container from '../../../constants/Container';

const EditCustomerView = () => {
    const { data, loading, error, refetch } = useFetchData(AppURL.FrontOfficeURL + 'front/customer/add/options/list/view/');
    const toleOptions = ToleOptions(data?.tole);
    const provinceOptions = ProvinceOptions(data?.province);
    const tapSizeOptions = TapSizeOptions(data?.tap_size);
    const casteOptions = CasteOptions(data?.caste);
    const districtOptions = DistrictOptions(data?.district);
    const readerOptions = ReaderOptions(data?.reader);
    const [currentItem, setCurrentItem] = useState<any>({});
    const initialValues = {
        member_sn: currentItem?.member_sn || "",
        mem_name: currentItem?.mem_name || "",
        mem_name_nep: currentItem?.mem_name_nep || "",
        spouse_name: currentItem?.spouse_name || "",
        spouse_name_nep: currentItem?.spouse_name_nep || "",
        municipality: currentItem?.municipality || "",
        add_nep: currentItem?.add_nep || "",
        add_eng: currentItem?.add_eng || "",
        ward_no: currentItem?.ward_no || "",
        district: currentItem?.district || "",
        sms_mob_no: currentItem?.sms_mob_no || "",
        phone_no: currentItem?.phone_no || "",
        dob: currentItem?.dob || "",
        ctiz_no: currentItem?.ctiz_no || "",
        ctiz_issue_district: currentItem?.ctiz_issue_district || "",
        province: currentItem?.province || "",
        gender: currentItem?.gender || "",
        caste: currentItem?.caste || "",
        pan_no: currentItem?.pan_no || "",
        family_male_no: currentItem?.family_male_no || "",
        family_female_no: currentItem?.family_female_no || "",
        father_name: currentItem?.father_name || "",
        father_name_nep: currentItem?.father_name_nep || "",
        grand_father_name: currentItem?.grand_father_name || "",
        grand_father_name_nep: currentItem?.grand_father_name_nep || "",
        old_sys_no: currentItem?.old_sys_no || "",
        reg_date_n: currentItem?.reg_date_n || "",
        meter_conn_date: currentItem?.meter_conn_date || "",
        marga_tole: currentItem?.marga_tole || "",
        meter_reading_zone: currentItem?.meter_reading_zone || "",
        serial_no: currentItem?.serial_no || "",
        serial_suffix: currentItem?.serial_suffix || "",
        area_no: currentItem?.area_no || "",
        meter_status: currentItem?.meter_status || "",
        customer_type: currentItem?.customer_type || "",
        meter_type: currentItem?.meter_type || "",
        tap_type: currentItem?.tap_type || "",
        tap_no: currentItem?.tap_no || "",
        discount_unit: currentItem?.discount_unit || "",
        reader: currentItem?.reader || "",
        reading_day: currentItem?.reading_day || "",
        meter_sn: currentItem?.meter_sn || "",
        reading_effective: currentItem?.reading_effective || "",
        consumers_no: currentItem?.consumers_no || "",
        emi: currentItem?.emi || "",
        tap_status: currentItem?.tap_status || "",
        nak_sa_no: currentItem?.nak_sa_no || "",
        kitta_no: currentItem?.kitta_no || "",
        area_land: currentItem?.area_land || "",
        purja_no: currentItem?.purja_no || "",
        house_no: currentItem?.house_no || "",
        sadhiyar_no: currentItem?.sadhiyar_no || "",
        branch: currentItem?.branch || "",
        active: currentItem?.active || "",
        block_no: currentItem?.block_no || "",
        area_supply: currentItem?.area_supply || "",
        tap_size: currentItem?.tap_size || "",
        ferrule_meter_distance: currentItem?.ferrule_meter_distance || "",
        ground_level_ferrule: currentItem?.ground_level_ferrule || "",
        distance: currentItem?.distance || "",
        mian_pipe_size: currentItem?.mian_pipe_size || "",
        photo: "",
        citz_photo: "",
        thumb_photo: "",
        signature1: "",
        lal_purja: "",
    };

    const { values, errors, touched, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        // validationSchema: districtValidationSchema,
        enableReinitialize: true,
        onSubmit: async (values, action) => {
            const formData = new FormData();
            Object.keys(values).forEach((key) => {
                const value = (values as Record<string, any>)[key];
                if (value !== undefined && value !== null && value !== "") {
                    formData.append(key, value);
                }
            });

            try {
                await putDataToTheServer(AppURL.FrontOfficeURL + 'front/customer/customer/retrieve/update/view/'+values.member_sn, formData).then((res) => {
                    ToastSuccess({ message: res?.message });
                });
            } catch (error) {
                console.log(error);
            }
        },
    });
    const { data: district_list, loading: district_loading, error: district_error } = useFetchSubData(AppURL.FrontOfficeURL + 'province/wise/district/municipality/options/list/?province_id=' + values.province, values.province);
    const districtListOptions = DistrictOptions(district_list?.province);

    const { data: municipality_list, loading: municipality_loading, error: municipality_error } = useFetchSubData(AppURL.FrontOfficeURL + 'province/wise/district/municipality/options/list/?district_id=' + values.district, values.district);
    const municipalityListOptions = MunicipalityOptions(municipality_list?.district);
    const handleKeyDown = async (e: any) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            try {
                await fetchDataFromApi(AppURL.FrontOfficeURL + 'front/customer/customer/retrieve/update/view/' + values.member_sn).then((res) => {
                    setCurrentItem(res);
                });
            } catch (error) {
                console.log(error);
            }
        }
    };
    return (
        <Container padding>
            <div className='mb-4 bg-green-200'>
                <InputTextBox name='member_sn' type='number' placeholder='Enter Customer No' onKeyPress={handleKeyDown} value={values.member_sn} handleChange={handleChange} />
            </div>
            <form onSubmit={handleSubmit} encType="multipart/form-data">
                <Grid container columnSpacing={2} rowSpacing={1}>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            prefix={<FiUser />}
                            name='mem_name'
                            label='Member Name'
                            handleChange={handleChange}
                            value={values.mem_name}
                            handleBlur={handleBlur}
                            required={true}
                            placeholder='Enter Member Name'
                            touched={!!touched.mem_name}
                            error={typeof errors.mem_name === 'string' ? errors.mem_name : undefined}
                        />

                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <NepaliInputBox
                            label='Member Name(Nepali)'
                            name='mem_name_nep'
                            value={values.mem_name_nep}
                            handleChange={(e: any) => handleNepaliInputChange(e, { setFieldValue, name: 'mem_name_nep' })}
                            required={true}
                            handleBlur={handleBlur}
                            placeholder='Enter Member Name(Nepali)'
                            error={typeof errors.mem_name_nep === 'string' ? errors.mem_name_nep : undefined}
                            touched={!!touched.mem_name_nep}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            prefix={<IoPeopleCircleOutline />}
                            label="Spouse's Name"
                            name='spouse_name'
                            handleChange={handleChange}
                            value={values.spouse_name}
                            handleBlur={handleBlur}
                            error={typeof errors.spouse_name === 'string' ? errors.spouse_name : undefined}
                            touched={!!touched.spouse_name}
                            placeholder='Enter Spouse Name'
                            required={true}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <NepaliInputBox
                            label="Spouse's Name(Nepali)"
                            name='spouse_name_nep'
                            handleChange={(e: any) => handleNepaliInputChange(e, { setFieldValue, name: 'spouse_name_nep' })}
                            value={values.spouse_name_nep}
                            handleBlur={handleBlur}
                            error={typeof errors.spouse_name_nep === 'string' ? errors.spouse_name_nep : undefined}
                            touched={!!touched.spouse_name_nep}
                            placeholder="Spouse's Name(Nepali)"
                            required={true} />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            prefix={<CiLocationOn />}
                            label="Address"
                            name='add_eng'
                            handleChange={handleChange}
                            value={values.add_eng}
                            handleBlur={handleBlur}
                            error={typeof errors.add_eng === 'string' ? errors.add_eng : undefined}
                            touched={!!touched.add_eng}
                            placeholder="Enter Address"
                            required={true}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <NepaliInputBox
                            label="Address(Nepali)"
                            name='add_nep'
                            handleChange={(e: any) => handleNepaliInputChange(e, { setFieldValue, name: 'add_nep' })}
                            value={values.add_nep}
                            handleBlur={handleBlur}
                            error={typeof errors.add_nep === 'string' ? errors.add_nep : undefined}
                            touched={!!touched.add_nep}
                            placeholder='Enter address(Nepali)'
                            required={true} />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='number'
                            prefix={<PiNumberCircleNineThin />}
                            label='Ward No.'
                            name='ward_no'
                            handleChange={handleChange}
                            value={values.ward_no}
                            handleBlur={handleBlur}
                            error={typeof errors.ward_no === 'string' ? errors.ward_no : undefined}
                            touched={!!touched.ward_no}
                            placeholder='00'
                            required={true} />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            prefix={<MdOutlinePhone />}
                            name='phone_no'
                            handleChange={(e: any) => handleChangePhone(e, { setFieldValue, name: 'phone_no' })}
                            handleBlur={handleBlur}
                            value={values.phone_no}
                            placeholder='XXX-XXXXXXX'
                            label='Phone Number'
                            error={typeof errors.phone_no === 'string' ? errors.phone_no : undefined}
                            touched={!!touched.phone_no}
                            required={true}
                        />

                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            prefix={<MdOutlinePhone />}
                            label='SMS Mobile No.'
                            name='sms_mob_no'
                            handleChange={(e: any) => handleChangePhone(e, { setFieldValue, name: 'sms_mob_no' })}
                            handleBlur={handleBlur}
                            value={values.sms_mob_no}
                            error={typeof errors.sms_mob_no === 'string' ? errors.sms_mob_no : undefined}
                            touched={!!touched.sms_mob_no}
                            placeholder='XXX-XXXXXXX'
                            required={true}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            prefix={<CiCalendarDate />}
                            handleChange={(e: any) => handleChangeDate(e, { setFieldValue, name: 'dob' })}
                            label='DOB(BS)'
                            name='dob'
                            handleBlur={handleBlur}
                            value={values.dob}
                            error={typeof errors.dob === 'string' ? errors.dob : undefined}
                            touched={!!touched.dob}
                            placeholder='XXXX/XX/XX'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            label='Citizenship No.'
                            name='ctiz_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.ctiz_no}
                            error={typeof errors.ctiz_no === 'string' ? errors.ctiz_no : undefined}
                            touched={!!touched.ctiz_no}
                            placeholder='000-000-0'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <SelectionBox
                            label='Province'
                            options={provinceOptions}
                            handleChange={(name: any, selectedOption: any) => {
                                setFieldValue('district', '');
                                setFieldValue("municipality", '');
                                setFieldValue(name, selectedOption.value);
                            }
                            }
                            value={values.province}
                            required={false}
                            placeholder='Select province'
                            name='province'
                            handleBlur={() => {
                                handleBlur({ target: { name: 'province' } });
                            }}
                            errors={typeof errors.province === 'string' ? errors.province : undefined}  // Use `errors` if that's the expected prop
                            touched={!!touched.province}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <SelectionBox
                            label='District'
                            options={districtListOptions}
                            handleChange={(name: any, selectedOption: any) => {
                                setFieldValue("municipality", '');
                                setFieldValue(name, selectedOption.value)
                            }
                            }
                            required={false}
                            placeholder='Select district'
                            name='district'
                            handleBlur={() => {
                                handleBlur({ target: { name: 'district' } });
                            }}
                            value={values.district}
                            errors={typeof errors.district === 'string' ? errors.district : undefined}  // Use `errors` if that's the expected prop
                            touched={!!touched.district}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <SelectionBox
                            label='Municipality'
                            options={municipalityListOptions}
                            handleChange={(name: any, selectedOption: any) => {
                                setFieldValue(name, selectedOption.value)
                            }
                            }
                            required={false}
                            placeholder='Select municipality'
                            name='municipality'
                            handleBlur={() => {
                                handleBlur({ target: { name: 'municipality' } });
                            }}
                            value={values.municipality}
                            errors={typeof errors.municipality === 'string' ? errors.municipality : undefined}  // Use `errors` if that's the expected prop
                            touched={!!touched.municipality}
                        />
                    </Grid>

                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <DefaultSelectInputBox
                            label='Citizenship Issue District'
                            options={districtOptions}
                            optionSelect={(name: any, selectedOption: any) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            required={false}
                            placeholder='Select District'
                            name='ctiz_issue_district'
                            handleBlur={() => {
                                handleBlur({ target: { name: 'ctiz_issue_district' } });
                            }}
                            value={values.ctiz_issue_district}
                            errors={typeof errors.ctiz_issue_district === 'string' ? errors.ctiz_issue_district : undefined}  // Use `errors` if that's the expected prop
                            touched={!!touched.ctiz_issue_district}
                        />
                    </Grid>

                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <DefaultSelectInputBox
                            label='Gender'
                            options={GenderOptions}
                            optionSelect={(name: any, selectedOption: any) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            required={false}
                            placeholder='Select Gender'
                            name='gender'
                            handleBlur={() => {
                                handleBlur({ target: { name: 'gender' } });
                            }}
                            value={values.gender}
                            errors={typeof errors.gender === 'string' ? errors.gender : undefined}  // Use `errors` if that's the expected prop
                            touched={!!touched.gender}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <SelectionBox
                            label='Caste'
                            options={casteOptions}
                            handleChange={(name: any, selectedOption: any) => {
                                setFieldValue(name, selectedOption?.value)
                            }
                            }
                            required={false}
                            placeholder='Select Caste'
                            name='caste'
                            handleBlur={() => {
                                handleBlur({ target: { name: 'caste' } });
                            }}
                            value={values.caste}
                            errors={typeof errors.caste === 'string' ? errors.caste : undefined}  // Use `errors` if that's the expected prop
                            touched={!!touched.caste}
                        />

                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            label='Pan No.'
                            name='pan_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.pan_no}
                            error={typeof errors.pan_no === 'string' ? errors.pan_no : undefined}
                            touched={!!touched.pan_no}
                            placeholder='000-000'
                            required={false} />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='number'
                            label='Family Male No.'
                            name='family_male_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.family_male_no}
                            error={typeof errors.family_male_no === 'string' ? errors.family_male_no : undefined}
                            touched={!!touched.family_male_no}
                            placeholder='0'
                            required={false} />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='number'
                            label='Family Female No.'
                            name='family_female_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.family_female_no}
                            error={typeof errors.family_female_no === 'string' ? errors.family_female_no : undefined}
                            touched={!!touched.family_female_no}
                            placeholder='0'
                            required={false} />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox type='text'
                            label='Father Name'
                            name='father_name'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.father_name}
                            error={typeof errors.father_name === 'string' ? errors.father_name : undefined}
                            touched={!!touched.father_name}
                            placeholder='Enter father name'
                            required={false} />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <NepaliInputBox
                            label='Father Name(Nepali)'
                            name='father_name_nep'
                            handleChange={(e: any) => handleNepaliInputChange(e, { setFieldValue, name: 'father_name_nep' })}
                            value={values.father_name_nep}
                            handleBlur={handleBlur}
                            placeholder='Enter father name(nepali)'
                            error={typeof errors.father_name_nep === 'string' ? errors.father_name_nep : undefined}
                            touched={!!touched.father_name_nep}
                            required={false} />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox type='text'
                            label='Grandfather Name'
                            name='grand_father_name'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.grand_father_name}
                            error={typeof errors.grand_father_name === 'string' ? errors.grand_father_name : undefined}
                            touched={!!touched.grand_father_name}
                            placeholder='Enter Grandfather name'
                            required={false} />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <NepaliInputBox
                            label='Grandfather Name(Nepali)'
                            name='grand_father_name_nep'
                            handleChange={(e: any) => handleNepaliInputChange(e, { setFieldValue, name: 'grand_father_name_nep' })}
                            value={values.grand_father_name_nep}
                            handleBlur={handleBlur}
                            error={typeof errors.grand_father_name_nep === 'string' ? errors.grand_father_name_nep : undefined}
                            touched={!!touched.grand_father_name_nep}
                            placeholder='Enter Grandfather Name(Nepali)'
                            required={false} />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            prefix={<PiNumberCircleNineThin />}
                            label='Old System No'
                            name='old_sys_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.old_sys_no}
                            error={typeof errors.old_sys_no === 'string' ? errors.old_sys_no : undefined}
                            touched={!!touched.old_sys_no}
                            placeholder='SYS-001'
                            required={false} />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            prefix={<PiNumberCircleNineThin />}
                            label='Meter Conn. Date'
                            handleChange={(e: any) => handleChangeDate(e, { setFieldValue, name: 'meter_conn_date' })}
                            name='meter_conn_date'
                            handleBlur={handleBlur}
                            value={values.meter_conn_date}
                            error={typeof errors.meter_conn_date === 'string' ? errors.meter_conn_date : undefined}
                            touched={!!touched.meter_conn_date}
                            placeholder='XXXX/XX/XX'
                            required={false} />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <DefaultSelectInputBox
                            label="Marga/Tole"
                            options={toleOptions}
                            name='marga_tole'
                            required={false}
                            placeholder='Select Active User'
                            optionSelect={(name: any, selectedOption: any) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            handleBlur={() => {
                                handleBlur({ target: { name: 'marga_tole' } });
                            }}
                            value={values.marga_tole}
                            errors={typeof errors.marga_tole === 'string' ? errors.marga_tole : undefined}  // Use `errors` if that's the expected prop
                            touched={!!touched.marga_tole}
                        />
                    </Grid>

                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            label='Meter Reading Zone'
                            name='meter_reading_zone'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.meter_reading_zone}
                            error={typeof errors.meter_reading_zone === 'string' ? errors.meter_reading_zone : undefined}  // Use `errors` if that's the expected prop
                            touched={!!touched.meter_reading_zone}
                            placeholder='Enter Meter Reading Zone'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            label='Serial No.'
                            name='serial_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.serial_no}
                            error={typeof errors.serial_no === 'string' ? errors.serial_no : undefined}  // Use `errors` if that's the expected prop
                            touched={!!touched.serial_no}
                            placeholder='Enter Serial No'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            label='Meter Serial No.'
                            name='meter_sn'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.meter_sn}
                            error={typeof errors.meter_sn === 'string' ? errors.meter_sn : undefined}  // Use `errors` if that's the expected prop
                            touched={!!touched.meter_sn}
                            placeholder='Enter Meter Serial No'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            label='Serial Suffix'
                            name='serial_suffix'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.serial_suffix}
                            error={typeof errors.serial_suffix === 'string' ? errors.serial_suffix : undefined}  // Use `errors` if that's the expected prop
                            touched={!!touched.serial_suffix}
                            placeholder='Enter Serial Suffix'
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='number'
                            prefix={<PiNumberCircleNineThin />}
                            label='Area No.'
                            name='area_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.area_no}
                            error={typeof errors.area_no === 'string' ? errors.area_no : undefined}  // Use `errors` if that's the expected prop
                            touched={!!touched.area_no}
                            placeholder='Area No.'
                            required={false} />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <DefaultSelectInputBox
                            label='Meter Status'
                            options={MeterStatusOptions}
                            name='meter_status'
                            required={false}
                            placeholder='Select meter status'
                            optionSelect={(name: any, selectedOption: any) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            handleBlur={() => {
                                handleBlur({ target: { name: 'meter_status' } });
                            }}
                            value={values.meter_status}
                            touched={!!touched.meter_status}
                            errors={typeof errors.meter_status === 'string' ? errors.meter_status : undefined}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <DefaultSelectInputBox
                            label='Customer Type'
                            options={MemberTypeOptions}
                            name='customer_type'
                            required={false}
                            placeholder='Select Ccustomer type'
                            optionSelect={(name: any, selectedOption: any) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            handleBlur={() => {
                                handleBlur({ target: { name: 'customer_type' } });
                            }}
                            value={values.customer_type}
                            touched={!!touched.customer_type}
                            errors={typeof errors.customer_type === 'string' ? errors.customer_type : undefined}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <DefaultSelectInputBox
                            label='Meter Type'
                            options={MeterTypeOptions}
                            name='meter_type'
                            required={false}
                            placeholder='Meter Type'
                            optionSelect={(name: any, selectedOption: any) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            handleBlur={() => {
                                handleBlur({ target: { name: 'meter_type' } });
                            }}
                            value={values.meter_type}
                            touched={!!touched.meter_type}
                            errors={typeof errors.meter_type === 'string' ? errors.meter_type : undefined}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <DefaultSelectInputBox
                            label='Tap Type'
                            options={TapTypeOptions}
                            name='tap_type'
                            required={false}
                            placeholder='Tap Type'
                            optionSelect={(name: any, selectedOption: any) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            handleBlur={() => {
                                handleBlur({ target: { name: 'tap_type' } });
                            }}
                            value={values.tap_type}
                            touched={!!touched.tap_type}
                            errors={typeof errors.tap_type === 'string' ? errors.tap_type : undefined}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <DefaultSelectInputBox
                            label='Tap Size'
                            options={tapSizeOptions}
                            name='tap_size'
                            required={false}
                            placeholder='Tap Size'
                            optionSelect={(name: any, selectedOption: any) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            handleBlur={() => {
                                handleBlur({ target: { name: 'tap_size' } });
                            }}
                            value={values.tap_size}
                            touched={!!touched.tap_size}
                            errors={typeof errors.tap_size === 'string' ? errors.tap_size : undefined}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='number'
                            prefix={<PiNumberCircleNineThin />}
                            label='Discount Unit'
                            name='discount_unit'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.discount_unit}
                            touched={!!touched.discount_unit}
                            error={typeof errors.discount_unit === 'string' ? errors.discount_unit : undefined}
                            placeholder='Discount Unit'
                            required={false} />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='number'
                            prefix={<PiNumberCircleNineThin />}
                            label='Tap No'
                            name='tap_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.tap_no}
                            touched={!!touched.tap_no}
                            error={typeof errors.tap_no === 'string' ? errors.tap_no : undefined}
                            placeholder='Enter tap no.'
                            required={false} />
                    </Grid>

                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <DefaultSelectInputBox
                            label='Reader'
                            options={readerOptions}
                            name='reader'
                            required={false}
                            placeholder='Select reader'
                            optionSelect={(name: any, selectedOption: any) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            handleBlur={() => {
                                handleBlur({ target: { name: 'reader' } });
                            }}
                            value={values.reader}
                            touched={!!touched.reader}
                            errors={typeof errors.reader === 'string' ? errors.reader : undefined}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='number'
                            label='Reading Day'
                            name='reading_day'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.reading_day}
                            touched={!!touched.reading_day}
                            error={typeof errors.reading_day === 'string' ? errors.reading_day : undefined}
                            placeholder='1-31'
                            required={false} />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            label='Registration Date'
                            name='reg_date_n'
                            handleChange={(e: any) => handleChangeDate(e, { setFieldValue, name: 'reg_date_n' })}
                            handleBlur={handleBlur}
                            value={values.reg_date_n}
                            touched={!!touched.reg_date_n}
                            error={typeof errors.reg_date_n === 'string' ? errors.reg_date_n : undefined}
                            placeholder='XXXX/XX/XX'
                            required={false}
                        />
                    </Grid>

                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            label='Reading Effective'
                            name='reading_effective'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.reading_effective}
                            touched={!!touched.reading_effective}
                            error={typeof errors.reading_effective === 'string' ? errors.reading_effective : undefined}
                            placeholder='Reading Effective '
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='number'
                            label='No Of customers'
                            name='consumers_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.consumers_no}
                            touched={!!touched.consumers_no}
                            error={typeof errors.consumers_no === 'string' ? errors.consumers_no : undefined}
                            placeholder='No. Of Consumers'
                            required={false}
                        />
                    </Grid>

                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <SelectionBox
                            label='Tap Status'
                            options={TapStatusOptions}
                            name='tap_status'
                            required={false}
                            placeholder='Select tap status'
                            handleChange={(name: any, selectedOption: any) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            handleBlur={() => {
                                handleBlur({ target: { name: 'tap_status' } });
                            }}
                            value={values.tap_status}
                            touched={!!touched.tap_status}
                            errors={typeof errors.tap_status === 'string' ? errors.tap_status : undefined}
                        />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='number'
                            label='Sadhiyar No'
                            name='sadhiyar_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.sadhiyar_no}
                            touched={!!touched.sadhiyar_no}
                            error={typeof errors.sadhiyar_no === 'string' ? errors.sadhiyar_no : undefined}
                            placeholder='Sadhiyar No.'
                            required={false}
                        />
                    </Grid>
                </Grid>
                <AppSpace />
                <SecHeading type='add' icon={<PiIslandLight />} label='Land Details' />
                <Grid container columnSpacing={0.5} rowSpacing={0.5}>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='number'
                            label='Naksha No'
                            name='nak_sa_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.nak_sa_no}
                            placeholder='Naksha No'
                            touched={!!touched.nak_sa_no}
                            error={typeof errors.nak_sa_no === 'string' ? errors.nak_sa_no : undefined}
                            required={false} />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='number'
                            label='Kitta No'
                            name='kitta_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.kitta_no}
                            placeholder='Kitta No'
                            touched={!!touched.kitta_no}
                            error={typeof errors.kitta_no === 'string' ? errors.kitta_no : undefined}
                            required={false} />
                    </Grid>

                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            label='Area of Land'
                            name='area_land'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.area_land}
                            placeholder='Area of Land'
                            touched={!!touched.area_land}
                            error={typeof errors.area_land === 'string' ? errors.area_land : undefined}
                            required={false} />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            prefix={<TbHexagonNumber2 />}
                            label='House No.'
                            name='house_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.house_no}
                            placeholder='House No.'
                            touched={!!touched.house_no}
                            error={typeof errors.house_no === 'string' ? errors.house_no : undefined}
                            required={false} />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='number'
                            label='Purja No.'
                            name='purja_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.purja_no}
                            placeholder='Purja No.'
                            touched={!!touched.purja_no}
                            error={typeof errors.purja_no === 'string' ? errors.purja_no : undefined}
                            required={false} />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            label='Area Supply No.'
                            name='area_supply'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.area_supply}
                            placeholder='Area Supply No.'
                            touched={!!touched.area_supply}
                            error={typeof errors.area_supply === 'string' ? errors.area_supply : undefined}
                            required={false} />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='number'
                            prefix={<GiAscendingBlock />}
                            label='Block No.'
                            name='block_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.block_no}
                            touched={!!touched.block_no}
                            error={typeof errors.block_no === 'string' ? errors.block_no : undefined}
                            placeholder='Enter Block No.'
                            required={false} />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            label='Ferrule Meter Distance'
                            name='ferrule_meter_distance'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.ferrule_meter_distance}
                            touched={!!touched.ferrule_meter_distance}
                            error={typeof errors.ferrule_meter_distance === 'string' ? errors.ferrule_meter_distance : undefined}
                            placeholder='Ferrule Meter Distance'
                            required={false} />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            label='Ground Level Ferrule'
                            name='ground_level_ferrule'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.ground_level_ferrule}
                            touched={!!touched.ground_level_ferrule}
                            error={typeof errors.ground_level_ferrule === 'string' ? errors.ground_level_ferrule : undefined}
                            placeholder='Ground Level Ferrule'
                            required={false} />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='text'
                            prefix={<GiPathDistance />}
                            label='Distance'
                            name='distance'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.distance}
                            touched={!!touched.distance}
                            error={typeof errors.distance === 'string' ? errors.distance : undefined}
                            placeholder='Enter distance'
                            required={false} />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <InputTextBox
                            type='number'
                            label='Mian Pipe Size'
                            name='mian_pipe_size'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.mian_pipe_size}
                            touched={!!touched.mian_pipe_size}
                            error={typeof errors.mian_pipe_size === 'string' ? errors.mian_pipe_size : undefined}
                            placeholder='Enter mian pipe size'
                            required={false} />
                    </Grid>

                </Grid>
                <AppSpace />
                <SecHeading type='add' icon={<IoDocumentsOutline />} label='Documents' />
                <Grid container columnSpacing={2} rowSpacing={1}>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <FileTextBox
                            type='file'
                            label='Citizenship Photo'
                            name='citz_photo'
                            handleBlur={handleBlur}
                            // ref={(el) => (fileInputRefs.current['citz_photo'] = el)}
                            handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                const file = e.target.files?.[0];
                                if (file) {
                                    setFieldValue("citz_photo", file); // Handle the file change correctly
                                }
                            }}
                            touched={!!touched.citz_photo}
                            error={typeof errors.citz_photo === 'string' ? errors.citz_photo : undefined}
                            required={false} />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <FileTextBox
                            type='file'
                            label='Photo'
                            name='photo'
                            handleBlur={handleBlur}
                            // ref={(el) => (fileInputRefs.current['photo'] = el)}

                            handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                const file = e.target.files?.[0];
                                if (file) {
                                    setFieldValue("photo", file); // Handle the file change correctly
                                }
                            }}
                            touched={!!touched.photo}
                            error={typeof errors.photo === 'string' ? errors.photo : undefined}
                            required={false} />
                    </Grid>

                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <FileTextBox
                            type='file'
                            label='Thub Print Left/Right'
                            name='thumb_photo'
                            handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                const file = e.target.files?.[0];
                                if (file) {
                                    setFieldValue("thumb_photo", file); // Handle the file change correctly
                                }
                            }}
                            // ref={(el) => (fileInputRefs.current['thumb_photo'] = el)}

                            handleBlur={handleBlur}
                            touched={!!touched.thumb_photo}
                            error={typeof errors.thumb_photo === 'string' ? errors.thumb_photo : undefined}
                            required={false} />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <FileTextBox
                            type='file'
                            handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                const file = e.target.files?.[0];
                                if (file) {
                                    setFieldValue("signature1", file); // Handle the file change correctly
                                }
                            }}
                            // ref={(el) => (fileInputRefs.current['signature1'] = el)}
                            label='Signature'
                            name='signature1'
                            handleBlur={handleBlur}
                            touched={!!touched.signature1}
                            error={typeof errors.signature1 === 'string' ? errors.signature1 : undefined}
                            required={false} />
                    </Grid>
                    <Grid item xl={3} lg={4} sm={6} md={4} xs={12}>
                        <FileTextBox
                            type='file'
                            label='Lal Purja'
                            name='lal_purja'
                            // ref={(el) => (fileInputRefs.current['lal_purja'] = el)}
                            handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                const file = e.target.files?.[0];
                                if (file) {
                                    setFieldValue("lal_purja", file); // Handle the file change correctly
                                }
                            }}
                            handleBlur={handleBlur}
                            touched={!!touched.lal_purja}
                            error={typeof errors.lal_purja === 'string' ? errors.lal_purja : undefined}
                            required={false}
                        />
                    </Grid>

                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <EndBaseLine top={10}>
                            <Button btn_type='save' loading={isSubmitting} type='submit' el='button' />
                        </EndBaseLine>
                    </Grid>
                </Grid>
            </form>
        </Container>
    )
}

export default EditCustomerView